var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"443a1b1c0a07f0f1b33beaced6d3c7c8b4de5ed5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hoyer-xp@harlapp-gmbh"]={id:"443a1b1c0a07f0f1b33beaced6d3c7c8b4de5ed5"};
      